import React, { Component } from 'react';
import * as signalR from '@microsoft/signalr';
import { SmallButton } from "./common/Buttons";
import { ChooseMethod } from "./common/ChooseMethod";
import mfaOneTouchImg from "../images/mfa-app-notification.png";
import mfaOneTouchTimeoutImg from "../images/mfa-app-notification-timeout.png";
import { t } from "./helper/ClientAppLocalizer";

const pendingStatus = 1;
const deniedStatus = 2;
const expiredStatus = 4;


export class OneTouch extends Component {
    static displayName = OneTouch.name;

    constructor(props) {
        super(props);
        this.state = {
            hubConnection: null,
            requestId: "",
            pushSent: props.pushSent,
            error: false,
            timeSent: null,
            errorMessage: null
        };

        this.fetchPushStatus = this.fetchPushStatus.bind(this);
        this.verifyPush = this.verifyPush.bind(this);
        this.handleVerifyPushResult = this.handleVerifyPushResult.bind(this);


    }

    componentDidMount() {
        const hubConnection = window.signalrMock || new signalR.HubConnectionBuilder()
            .withUrl('/sr/mfa')
            .build();

        this.setState({ hubConnection }, () => {
            this.state.hubConnection
                .start()
                .then(() => console.log('Connection started!'))
                .catch(err => {
                    //'Error while establishing connection');                    
                });

            let _me = this;
            this.state.hubConnection.on('OneTouchResponseReceived', (receivedMessage) => {
                _me.setState({ requestId: receivedMessage });

                //if polling already handled this then don't try again
                if (this.state.pushSent) {
                    this.verifyPush();
                }
            });
        });

        if (this.state.pushSent) {
            this.setState({ timeSent: Date.now() });
        } else {
            //only do this when explicitly set to false
            this.handleSendPush();
        }

        //check the status every x seconds to ensure we're still functional if signalr fails us
        let pollingInterval = 5000; //5 seconds
        let pollingTimer = setInterval(() => {
            //only check status once push has been sent
            if (this.state.pushSent) {
                this.fetchPushStatus().then(data => {
                    if (data !== undefined && data.requestStatus !== pendingStatus) {
                        this.handleVerifyPushResult(data);
                    }
                });
            }
        }, pollingInterval);

        this.setState({ pollingTimer: pollingTimer });

        let pollingTimeoutTimer = setInterval(() => {
            if (!this.state.error && this.state.pushSent && Date.now() - this.state.timeSent > 20000) {
                this.setState({ error: true });
            }
        }, 1000);

        this.setState({ pollingTimeoutTimer: pollingTimeoutTimer });

    }

    componentWillUnmount() {
        if (this.state.pollingTimer) {
            clearInterval(this.state.pollingTimer);
        }
        if (this.state.pollingTimeoutTimer) {
            clearInterval(this.state.pollingTimeoutTimer);
        }
    }

    //this method simply checks the status, polling requests are throttled server-side so don't abuse this method
    //verifyPush method is expecting null for requestId when polling, so state.requestId should be null or you will get locked out
    fetchPushStatus = () => {
        return fetch('/api/MFA/verifyPush',
            {
                method: 'post',
                headers: new Headers({ 'content-type': 'application/json' }),
                body: JSON.stringify({ requestId: this.state.requestId })
            })
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                }
            });
    }

    verifyPush = () => {
        //this.setState({ pushSent: false }); //prevent polling from also verifying

        this.fetchPushStatus()
            .then(data => this.handleVerifyPushResult(data))
            .catch(error => {
                //"Error Verifying Push");                
                this.setState({ error: true });
            });
    }

    handleVerifyPushResult = (data) => {
        const pushDeniedTxt = t("OneTouch.PushDeniedText");

        if (data === undefined) {
            return;
        }

        //this.setState({ pushSent: false }); //prevent additional verification requests

        if (data.success) {
            this.props.verificationComplete(data);
        }
        else if (data.requestStatus === deniedStatus || data.requestStatus === expiredStatus) {
            this.props.allowRetry(data.allowRetry, data.message, data.returnUrl, pushDeniedTxt);

            let errorMessage = t("OneTouch.RequestDenied");
            if (data.requestStatus === expiredStatus) {
                errorMessage = t("OneTouch.RequestExpired");
            }

            this.setState({ error: true, errorMessage: errorMessage });
        }
        else {
            throw new Error("Error Verifying Push");
        }
    }

    handleSendPush = () => {
        this.setState({ requestId: null, errorMessage: null });
        fetch('/api/MFA/sendPush', { method: 'post' })
            .then(results => {
                if (results.status === 200) {
                    this.setState({ pushSent: true, error: false, timeSent: Date.now() });
                    this.props.requestSent(this.props.method);
                }
                else {
                    throw new Error(results.statusText);
                }
            }).catch(error => {
                //"Error sending push notification");
                this.setState({ error: true });
            });
    };

    render() {
        const pushSent = this.state.pushSent;
        const error = this.state.error;
        const tryAgainTxt = t("OneTouch.TryAgain");
        const approveLoginRequestTxt = t("OneTouch.ApproveLoginRequest");
        const mobileNotificationSentTxt = t("OneTouch.MobileNotificationSentText");
        const noResponseTxt = t("OneTouch.NoResponseText");
        const noResponseDetTxt = t("OneTouch.NoResponseDetailedText");
        const noResponseSolTxt = t("OneTouch.NoResponseSolutionText");
        const warn = t("SystemMessages.CommonWarning");
        return (
            <div id="contentTouch">
                {pushSent && !error ? (
                    <div>
                        <img id="topImage" alt={t("Authy.DayforceLogo")} src={mfaOneTouchImg} style={{ maxHeight: 120, maxWidth: 120, alignContent: 'center' }} />
                        <p className="mfa-header">{approveLoginRequestTxt}</p>
                        <p className="mfa-text" >{mobileNotificationSentTxt}</p>
                        <p className="mfa-text" style={{ color: "black", fontWeight: "bold" }}>{warn}</p>
                    </div>
                ) : (
                        <div>
                            <img id="topImage" alt={t("Authy.DayforceLogo")} src={mfaOneTouchTimeoutImg} style={{ maxHeight: 120, maxWidth: 120, alignContent: 'center' }} />

                            {this.state.errorMessage ? <div className="mfa-text" style={{ marginBottom: 10, color: 'red', fontSize: '70%' }}>{this.state.errorMessage}</div> : <div> <p className="mfa-header">{noResponseTxt}</p> <p className="mfa-text">{noResponseDetTxt} </p> <p className="mfa-text">{noResponseSolTxt}</p></div>}

                            <div><SmallButton id="sendPush" onClick={this.handleSendPush}>{tryAgainTxt}</SmallButton></div>
                        </div>
                    )}
                <ChooseMethod changeVerificationMethod={this.props.changeVerificationMethod} lockoutMessage={this.props.lockoutMessage} />
            </div>
        );
    }
}